const key='qsmart-map-style-v1';
export async function loadMapStyle(){try{return globalThis.localStorage?.getItem(key)??null;}catch{return null;}}
export async function saveMapStyle(value:string){try{globalThis.localStorage?.setItem(key,value);}catch{}}
